// extracted by mini-css-extract-plugin
export default {"active":"styles_active__7S23h"};